// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
   Marketing / public-site design system for Revailo Sales (revailo-sales.com)
   ----------------------------------------------------------------------------
   A self-contained, Linear/Vercel-style system for the public pages (landing,
   pricing, features, legal, …). Everything is namespaced \`mk-\` so it never
   collides with the app stylesheet (styles.css). The marketing canvas is
   deliberately LIGHT and theme-independent — colors are hardcoded here so the
   pages look right regardless of the app's dark/light setting. The single
   accent is the Revailo Sales brand blue (#3C87F7), used sparingly.
   ============================================================================ */

.mk-root {
  --mk-ink: #0f172a;
  --mk-ink-soft: #334155;
  --mk-muted: #64748b;
  --mk-faint: #94a3b8;
  --mk-ghost: #b4bcca;
  --mk-line: #e6e9ef;
  --mk-line-soft: #eef1f6;
  --mk-surface: #f6f8fb;
  --mk-surface-soft: #fafbfd;
  --mk-dark: #0b1220;
  --mk-panel: #0b1220;
  --mk-accent: #3C87F7;
  --mk-accent-dark: #1D68D9;
  --mk-accent-bright: #5b9dff;
  --mk-accent-tint: #eaf2fe;

  min-height: 100%;
  width: 100%;
  background: #ffffff;
  color: var(--mk-ink);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  line-height: 1.5;
}

.mk-root *,
.mk-root *::before,
.mk-root *::after {
  box-sizing: border-box;
}

/* :where() so this contributes ZERO specificity. As a plain \`.mk-root a\` rule it
   scored (0,1,1) and beat every single-class colour utility on an anchor — so a
   \`text-white\` label on the near-black "Get started" button lost to the
   inherited ink and rendered black on black. It still gives anchors the default
   "inherit, no underline" look; it just no longer overrides a class that is
   explicitly setting a colour. */
:where(.mk-root a) {
  color: inherit;
  text-decoration: none;
}

/* ---------- Layout primitives ---------- */
.mk-container {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding-left: 24px;
  padding-right: 24px;
}

.mk-section {
  padding-top: 88px;
  padding-bottom: 88px;
}

.mk-section-sm {
  padding-top: 56px;
  padding-bottom: 56px;
}

@media (max-width: 640px) {
  .mk-section {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .mk-container {
    padding-left: 20px;
    padding-right: 20px;
  }
}

/* ---------- Type ---------- */
.mk-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--mk-accent-dark);
}
.mk-eyebrow-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--mk-accent);
}

.mk-h1,
.mk-h2,
.mk-h3 {
  margin: 0;
  color: var(--mk-ink);
  letter-spacing: -0.022em;
  font-weight: 600;
  line-height: 1.07;
}
.mk-h1 {
  font-size: 54px;
}
.mk-h2 {
  font-size: 42px;
}
.mk-h3 {
  font-size: 26px;
  line-height: 1.15;
}
@media (max-width: 720px) {
  .mk-h1 {
    font-size: 38px;
  }
  .mk-h2 {
    font-size: 30px;
  }
  .mk-h3 {
    font-size: 22px;
  }
}
.mk-muted-line {
  color: var(--mk-ghost);
}

.mk-lead {
  margin: 0;
  font-size: 18px;
  line-height: 1.6;
  color: var(--mk-muted);
}
@media (max-width: 720px) {
  .mk-lead {
    font-size: 16px;
  }
}

/* ---------- Buttons ---------- */
.mk-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 20px;
  border: 1px solid transparent;
  transition: background 0.15s, color 0.15s, border-color 0.15s, transform 0.15s;
  cursor: pointer;
  white-space: nowrap;
}
.mk-btn:active {
  transform: translateY(1px);
}
.mk-btn-primary {
  background: var(--mk-dark);
  color: #fff;
}
.mk-btn-primary:hover {
  background: #1e293b;
}
.mk-btn-accent {
  background: var(--mk-accent);
  color: #fff;
}
.mk-btn-accent:hover {
  background: var(--mk-accent-dark);
}
.mk-btn-secondary {
  background: #fff;
  color: var(--mk-ink);
  border-color: var(--mk-line);
}
.mk-btn-secondary:hover {
  background: var(--mk-surface-soft);
  border-color: var(--mk-ghost);
}
.mk-btn-ghost {
  background: transparent;
  color: var(--mk-ink-soft);
  padding: 9px 14px;
}
.mk-btn-ghost:hover {
  background: var(--mk-surface);
  color: var(--mk-ink);
}
.mk-btn-white {
  background: #fff;
  color: var(--mk-dark);
}
.mk-btn-white:hover {
  background: rgba(255, 255, 255, 0.9);
}
.mk-btn-outline-white {
  background: transparent;
  color: #fff;
  border-color: rgba(255, 255, 255, 0.25);
}
.mk-btn-outline-white:hover {
  background: rgba(255, 255, 255, 0.1);
}
.mk-btn-lg {
  padding: 14px 26px;
  font-size: 15px;
}

/* ---------- Header ---------- */
.mk-header {
  position: sticky;
  top: 0;
  z-index: 40;
  width: 100%;
  border-bottom: 1px solid var(--mk-line-soft);
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: saturate(180%) blur(12px);
}
.mk-header-inner {
  display: flex;
  height: 64px;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.mk-logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: -0.01em;
  color: var(--mk-ink);
}
.mk-logo-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: linear-gradient(135deg, var(--mk-accent), var(--mk-accent-dark));
  color: #fff;
  font-size: 15px;
  font-weight: 800;
  flex: none;
}
.mk-nav {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px;
  border-radius: 999px;
  background: var(--mk-surface);
}
.mk-nav-item {
  border-radius: 999px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 500;
  color: var(--mk-muted);
  transition: color 0.15s, background 0.15s;
}
.mk-nav-item:hover {
  color: var(--mk-ink);
}
.mk-nav-item.mk-active {
  color: var(--mk-ink);
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}
.mk-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.mk-header-signin {
  font-size: 13px;
  font-weight: 500;
  color: var(--mk-muted);
  padding: 8px 10px;
}
.mk-header-signin:hover {
  color: var(--mk-ink);
}
.mk-menu-btn {
  display: none;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 999px;
  border: 1px solid var(--mk-line);
  background: #fff;
  color: var(--mk-ink);
}
.mk-mobile-menu {
  border-top: 1px solid var(--mk-line-soft);
  background: #fff;
  padding: 8px 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.mk-mobile-item {
  border-radius: 10px;
  padding: 11px 12px;
  font-size: 14px;
  color: var(--mk-ink-soft);
}
.mk-mobile-item.mk-active {
  background: var(--mk-surface);
  font-weight: 600;
  color: var(--mk-ink);
}
@media (max-width: 900px) {
  .mk-nav {
    display: none;
  }
  .mk-menu-btn {
    display: inline-flex;
  }
  .mk-header-signin {
    display: none;
  }
}

/* ---------- Hero ---------- */
.mk-hero {
  padding-top: 72px;
  padding-bottom: 40px;
}
.mk-hero-inner {
  max-width: 760px;
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.mk-hero-center {
  margin: 0 auto;
  align-items: center;
  text-align: center;
}
.mk-hero-actions {
  display: flex;
  gap: 12px;
  margin-top: 6px;
  flex-wrap: wrap;
}
.mk-hero-center .mk-hero-actions {
  justify-content: center;
}
@media (max-width: 720px) {
  .mk-hero {
    padding-top: 48px;
  }
}

/* ---------- Section intro ---------- */
.mk-intro {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 680px;
}
.mk-intro-center {
  margin: 0 auto;
  align-items: center;
  text-align: center;
}

/* ---------- Cards ---------- */
.mk-card {
  border-radius: 20px;
  border: 1px solid var(--mk-line);
  background: #fff;
  padding: 26px;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
}
.mk-card-soft {
  border-color: transparent;
  background: var(--mk-surface);
}
.mk-card-hover:hover {
  border-color: var(--mk-ghost);
  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.06);
  transform: translateY(-2px);
}

.mk-dark {
  position: relative;
  overflow: hidden;
  border-radius: 28px;
  background: var(--mk-panel);
  color: #fff;
}

.mk-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  border: 1px solid var(--mk-line);
  background: #fff;
  color: var(--mk-muted);
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
}
.mk-badge-accent {
  border-color: #bfdcff;
  background: var(--mk-accent-tint);
  color: var(--mk-accent-dark);
}
.mk-badge-dark {
  border-color: rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.mk-glyph {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: var(--mk-accent-tint);
  color: var(--mk-accent-dark);
  flex: none;
}
.mk-glyph-dark {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

/* ---------- Feature grid ---------- */
.mk-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(1, 1fr);
}
@media (min-width: 640px) {
  .mk-grid-2,
  .mk-grid-3,
  .mk-grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 960px) {
  .mk-grid-3 {
    grid-template-columns: repeat(3, 1fr);
  }
  .mk-grid-4 {
    grid-template-columns: repeat(4, 1fr);
  }
}
.mk-feature-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.mk-feature-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mk-feature-title {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--mk-ink);
}
.mk-feature-body {
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--mk-muted);
}

/* ---------- Feature row (alternating) ---------- */
.mk-featurerow {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  align-items: center;
}
@media (min-width: 960px) {
  .mk-featurerow {
    grid-template-columns: 1fr 1fr;
    gap: 64px;
  }
  .mk-featurerow-reverse .mk-featurerow-text {
    order: 2;
  }
}
.mk-bullets {
  list-style: none;
  margin: 24px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mk-bullet {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 15px;
  line-height: 1.5;
  color: var(--mk-ink-soft);
}
.mk-bullet-check {
  margin-top: 1px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 999px;
  background: var(--mk-accent-tint);
  color: var(--mk-accent-dark);
  flex: none;
}

/* ---------- Stat band ---------- */
.mk-statband {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1px;
  overflow: hidden;
  border-radius: 24px;
  border: 1px solid var(--mk-line);
  background: var(--mk-line);
}
@media (min-width: 768px) {
  .mk-statband-4 {
    grid-template-columns: repeat(4, 1fr);
  }
  .mk-statband-3 {
    grid-template-columns: repeat(3, 1fr);
  }
}
.mk-stat {
  background: #fff;
  padding: 32px 24px;
  text-align: center;
}
.mk-stat-value {
  font-size: 34px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--mk-ink);
  line-height: 1;
  font-variant-numeric: tabular-nums;
}
.mk-stat-label {
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.4;
  color: var(--mk-faint);
}

/* ---------- Media / mock frames ---------- */
.mk-frame {
  border-radius: 18px;
  border: 1px solid var(--mk-line);
  background: var(--mk-surface-soft);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}
.mk-frame-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--mk-line-soft);
  background: #fff;
}
.mk-frame-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #e2e8f0;
}
.mk-frame-body {
  padding: 20px;
}

/* Bar/line mini viz used in mock frames */
.mk-bars {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  height: 160px;
}
.mk-bars > span {
  flex: 1;
  border-radius: 6px 6px 0 0;
  background: linear-gradient(180deg, var(--mk-accent-bright), var(--mk-accent));
  opacity: 0.9;
}
.mk-metric-row {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}
.mk-metric {
  flex: 1;
  border-radius: 12px;
  border: 1px solid var(--mk-line-soft);
  background: #fff;
  padding: 12px 14px;
}
.mk-metric-value {
  font-size: 20px;
  font-weight: 700;
  color: var(--mk-ink);
}
.mk-metric-label {
  font-size: 12px;
  color: var(--mk-faint);
  margin-top: 2px;
}

/* ---------- CTA band ---------- */
.mk-cta-inner {
  padding: 72px 32px;
  text-align: center;
}
.mk-cta-glow {
  pointer-events: none;
  position: absolute;
  top: -120px;
  left: 50%;
  transform: translateX(-50%);
  width: 460px;
  height: 300px;
  border-radius: 999px;
  background: var(--mk-accent);
  opacity: 0.22;
  filter: blur(100px);
}
.mk-cta-content {
  position: relative;
  max-width: 640px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
.mk-cta-title {
  margin: 0;
  font-size: 40px;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.08;
  color: #fff;
}
.mk-cta-body {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.62);
}
.mk-cta-actions {
  display: flex;
  gap: 12px;
  margin-top: 6px;
  flex-wrap: wrap;
  justify-content: center;
}
@media (max-width: 640px) {
  .mk-cta-inner {
    padding: 52px 22px;
  }
  .mk-cta-title {
    font-size: 30px;
  }
}

/* ---------- Accordion ---------- */
.mk-accordion {
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid var(--mk-line);
  background: #fff;
}
.mk-acc-item + .mk-acc-item {
  border-top: 1px solid var(--mk-line-soft);
}
.mk-acc-btn {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 22px;
  text-align: left;
  background: transparent;
  border: none;
}
.mk-acc-q {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.45;
  color: var(--mk-ink);
}
.mk-acc-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  border: 1px solid var(--mk-line);
  color: var(--mk-muted);
  flex: none;
  transition: transform 0.2s;
}
.mk-acc-open .mk-acc-icon {
  transform: rotate(45deg);
}
.mk-acc-body {
  padding: 0 48px 22px 22px;
  font-size: 14px;
  line-height: 1.65;
  color: var(--mk-muted);
}

/* ---------- Steps ---------- */
.mk-steps {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.mk-step {
  display: flex;
  gap: 16px;
  border-radius: 18px;
  border: 1px solid var(--mk-line);
  background: #fff;
  padding: 22px;
}
.mk-step-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: var(--mk-dark);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  flex: none;
}
.mk-step-title {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--mk-ink);
}
.mk-step-body {
  margin: 6px 0 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--mk-muted);
}

/* ---------- Quote ---------- */
.mk-quote {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
}
.mk-quote-text {
  font-size: 17px;
  line-height: 1.55;
  letter-spacing: -0.01em;
  color: var(--mk-ink);
  margin: 0;
}
.mk-quote-foot {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 12px;
}
.mk-quote-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 999px;
  background: var(--mk-dark);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  flex: none;
}
.mk-quote-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--mk-ink);
}
.mk-quote-role {
  font-size: 12px;
  color: var(--mk-faint);
}

/* ---------- Logo cloud ---------- */
.mk-logocloud {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
  padding: 28px 0;
  border-top: 1px solid var(--mk-line-soft);
  border-bottom: 1px solid var(--mk-line-soft);
}
.mk-logocloud-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--mk-faint);
}
.mk-logocloud-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 10px 22px;
  font-size: 15px;
  font-weight: 600;
  color: var(--mk-ghost);
}
.mk-logocloud-sep {
  color: var(--mk-line);
}

/* ---------- Pricing ---------- */
.mk-price-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr;
}
@media (min-width: 960px) {
  .mk-price-grid-3 {
    grid-template-columns: repeat(3, 1fr);
  }
  .mk-price-grid-4 {
    grid-template-columns: repeat(4, 1fr);
  }
}
.mk-price-card {
  display: flex;
  flex-direction: column;
  border-radius: 22px;
  border: 1px solid var(--mk-line);
  background: #fff;
  padding: 28px;
}
.mk-price-card-featured {
  border-color: var(--mk-accent);
  box-shadow: 0 12px 40px rgba(60, 135, 247, 0.16);
  position: relative;
}
.mk-price-name {
  font-size: 15px;
  font-weight: 700;
  color: var(--mk-ink);
}
.mk-price-tagline {
  margin: 6px 0 0;
  font-size: 13px;
  color: var(--mk-muted);
  min-height: 34px;
}
.mk-price-amount {
  margin-top: 18px;
  display: flex;
  align-items: baseline;
  gap: 4px;
}
.mk-price-value {
  font-size: 40px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--mk-ink);
}
.mk-price-period {
  font-size: 14px;
  color: var(--mk-faint);
}
.mk-price-features {
  list-style: none;
  margin: 22px 0 0;
  padding: 22px 0 0;
  border-top: 1px solid var(--mk-line-soft);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mk-price-feature {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--mk-ink-soft);
}
.mk-price-feature .mk-bullet-check {
  width: 18px;
  height: 18px;
}
.mk-price-cta {
  margin-top: 24px;
}

/* ---------- Timeline (changelog) ---------- */
.mk-timeline {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.mk-tl-item {
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 28px;
  padding-bottom: 40px;
  position: relative;
}
.mk-tl-rail {
  position: relative;
}
.mk-tl-date {
  font-size: 13px;
  font-weight: 600;
  color: var(--mk-faint);
  position: sticky;
  top: 90px;
}
.mk-tl-body {
  border-left: 1px solid var(--mk-line);
  padding-left: 28px;
  padding-bottom: 8px;
  position: relative;
}
.mk-tl-body::before {
  content: '';
  position: absolute;
  left: -5px;
  top: 6px;
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: var(--mk-accent);
  box-shadow: 0 0 0 4px #fff;
}
@media (max-width: 720px) {
  .mk-tl-item {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .mk-tl-body {
    border-left: none;
    padding-left: 0;
  }
  .mk-tl-body::before {
    display: none;
  }
  .mk-tl-date {
    position: static;
  }
}

/* ---------- Blog / post grid ---------- */
.mk-post {
  display: flex;
  flex-direction: column;
  gap: 14px;
  height: 100%;
}
.mk-post-thumb {
  border-radius: 14px;
  height: 168px;
  background: linear-gradient(135deg, var(--mk-accent-tint), #dbe8ff);
  position: relative;
  overflow: hidden;
}
.mk-post-thumb-alt {
  background: linear-gradient(135deg, #eef2f7, #dfe6f0);
}
.mk-post-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--mk-faint);
}
.mk-post-title {
  font-size: 17px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--mk-ink);
  line-height: 1.3;
}
.mk-post-excerpt {
  font-size: 14px;
  line-height: 1.6;
  color: var(--mk-muted);
  margin: 0;
}

/* ---------- Careers / job list ---------- */
.mk-jobgroup + .mk-jobgroup {
  margin-top: 36px;
}
.mk-jobgroup-title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--mk-faint);
  margin-bottom: 12px;
}
.mk-job {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 22px;
  border: 1px solid var(--mk-line);
  border-radius: 16px;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.mk-job + .mk-job {
  margin-top: 10px;
}
.mk-job:hover {
  border-color: var(--mk-ghost);
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.05);
}
.mk-job-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--mk-ink);
}
.mk-job-meta {
  font-size: 13px;
  color: var(--mk-faint);
  margin-top: 3px;
}

/* ---------- Status ---------- */
.mk-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 999px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
}
.mk-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
}
.mk-status-operational {
  background: #ecfdf3;
  color: #067647;
}
.mk-status-operational .mk-status-dot {
  background: #17b26a;
}
.mk-status-degraded {
  background: #fffaeb;
  color: #b54708;
}
.mk-status-degraded .mk-status-dot {
  background: #f79009;
}
.mk-status-maintenance {
  background: #eff4ff;
  color: #3538cd;
}
.mk-status-maintenance .mk-status-dot {
  background: #6172f3;
}
.mk-status-outage {
  background: #fef3f2;
  color: #b42318;
}
.mk-status-outage .mk-status-dot {
  background: #f04438;
}
.mk-uptime {
  display: flex;
  align-items: flex-end;
  gap: 2px;
}
.mk-uptime-cell {
  flex: 1;
  max-width: 7px;
  height: 30px;
  border-radius: 2px;
  background: #17b26a;
}
.mk-uptime-cell.mk-degraded {
  background: #f79009;
}
.mk-uptime-cell.mk-outage {
  background: #f04438;
}
.mk-status-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 22px;
  border: 1px solid var(--mk-line);
  border-radius: 14px;
  background: #fff;
}
.mk-status-row + .mk-status-row {
  margin-top: 10px;
}

/* ---------- Prose (legal / long text) ---------- */
.mk-prose {
  max-width: 760px;
  color: var(--mk-ink-soft);
}
.mk-prose h2 {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--mk-ink);
  margin: 40px 0 12px;
}
.mk-prose h3 {
  font-size: 17px;
  font-weight: 600;
  color: var(--mk-ink);
  margin: 26px 0 8px;
}
.mk-prose p {
  font-size: 15px;
  line-height: 1.7;
  color: var(--mk-ink-soft);
  margin: 0 0 14px;
}
.mk-prose ul {
  margin: 0 0 16px;
  padding-left: 20px;
}
.mk-prose li {
  font-size: 15px;
  line-height: 1.7;
  color: var(--mk-ink-soft);
  margin-bottom: 6px;
}
.mk-prose a {
  color: var(--mk-accent-dark);
  font-weight: 500;
}
.mk-prose a:hover {
  text-decoration: underline;
}
.mk-prose-lead {
  font-size: 15px;
  color: var(--mk-muted);
}

/* Two-column split for legal toc + content */
.mk-legal {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
}
@media (min-width: 960px) {
  .mk-legal {
    grid-template-columns: 220px 1fr;
    gap: 56px;
  }
}
.mk-legal-toc {
  position: sticky;
  top: 90px;
  align-self: start;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.mk-legal-toc a {
  font-size: 13px;
  color: var(--mk-muted);
  padding: 4px 0;
}
.mk-legal-toc a:hover {
  color: var(--mk-ink);
}
@media (max-width: 960px) {
  .mk-legal-toc {
    display: none;
  }
}

/* ---------- Footer ---------- */
.mk-footer {
  border-top: 1px solid var(--mk-line-soft);
  background: var(--mk-surface-soft);
}
.mk-footer-inner {
  padding: 56px 0;
}
.mk-footer-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px 32px;
}
@media (min-width: 640px) {
  .mk-footer-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 960px) {
  .mk-footer-grid {
    grid-template-columns: 1.5fr repeat(4, 1fr);
  }
}
.mk-footer-brand {
  grid-column: 1 / -1;
}
@media (min-width: 960px) {
  .mk-footer-brand {
    grid-column: auto;
  }
}
.mk-footer-tagline {
  margin: 16px 0 0;
  max-width: 260px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--mk-faint);
}
.mk-footer-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--mk-faint);
}
.mk-footer-links {
  list-style: none;
  margin: 16px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mk-footer-links a {
  font-size: 13px;
  color: var(--mk-muted);
}
.mk-footer-links a:hover {
  color: var(--mk-ink);
}
.mk-social {
  display: flex;
  gap: 8px;
  margin-top: 20px;
}
.mk-social a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  border: 1px solid var(--mk-line);
  color: var(--mk-faint);
}
.mk-social a:hover {
  color: var(--mk-ink);
  border-color: var(--mk-ghost);
}
.mk-footer-bottom {
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid var(--mk-line-soft);
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
}
@media (min-width: 640px) {
  .mk-footer-bottom {
    flex-direction: row;
    align-items: center;
  }
}
.mk-footer-copy {
  font-size: 12px;
  color: var(--mk-faint);
}
.mk-footer-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--mk-faint);
}
.mk-footer-status:hover {
  color: var(--mk-ink);
}

/* ---------- Generic helpers ---------- */
.mk-center {
  text-align: center;
}
@media (max-width: 640px) {
  .mk-hide-sm {
    display: none;
  }
}
.mk-stack {
  display: flex;
  flex-direction: column;
}
.mk-mt-8 {
  margin-top: 8px;
}
.mk-mt-16 {
  margin-top: 16px;
}
.mk-mt-24 {
  margin-top: 24px;
}
.mk-mt-32 {
  margin-top: 32px;
}
.mk-mt-40 {
  margin-top: 40px;
}
.mk-mt-56 {
  margin-top: 56px;
}
.mk-divider {
  height: 1px;
  background: var(--mk-line-soft);
  border: none;
  margin: 0;
}

/* Reveal-on-scroll (progressive; static under reduced motion) */
.mk-reveal {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1),
    transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: opacity, transform;
}
.mk-reveal.mk-in {
  opacity: 1;
  transform: none;
}
@media (prefers-reduced-motion: reduce) {
  .mk-reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/marketing.css"],"names":[],"mappings":"AAAA;;;;;;;;;iFASiF;;AAEjF;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;;EAEzB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB;qBACmB;EACnB,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;;;iCAKiC;AACjC;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;;;EAGE,SAAS;EACT,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,8EAA8E;EAC9E,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,uCAAuC;AACzC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,WAAW;EACX,4CAA4C;EAC5C,qCAAqC;EACrC,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4EAA4E;EAC5E,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;AAC3C;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;AACF;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,iEAAiE;AACnE;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,4BAA4B;EAC5B,UAAU;AACZ;AACA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;AACvC;AACA;EACE;;;IAGE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,4BAA4B;EAC5B,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kCAAkC;EAClC,8CAA8C;EAC9C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,aAAa;AACf;AACA;EACE,OAAO;EACP,0BAA0B;EAC1B,8EAA8E;EAC9E,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;EACtB,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,gDAAgD;EAChD,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mEAAmE;EACnE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qDAAqD;AACvD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,6CAA6C;AAC/C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,OAAO;EACP,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE;IACE,gCAAgC;IAChC,SAAS;EACX;AACF;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA,iCAAiC;AACjC;EACE,yCAAyC;EACzC,kCAAkC;AACpC;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,2CAA2C;EAC7C;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,SAAS;AACX;;AAEA,gEAAgE;AAChE;EACE,UAAU;EACV,2BAA2B;EAC3B;gDAC8C;EAC9C,+BAA+B;AACjC;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* ============================================================================\n   Marketing / public-site design system for Revailo Sales (revailo-sales.com)\n   ----------------------------------------------------------------------------\n   A self-contained, Linear/Vercel-style system for the public pages (landing,\n   pricing, features, legal, …). Everything is namespaced `mk-` so it never\n   collides with the app stylesheet (styles.css). The marketing canvas is\n   deliberately LIGHT and theme-independent — colors are hardcoded here so the\n   pages look right regardless of the app's dark/light setting. The single\n   accent is the Revailo Sales brand blue (#3C87F7), used sparingly.\n   ============================================================================ */\n\n.mk-root {\n  --mk-ink: #0f172a;\n  --mk-ink-soft: #334155;\n  --mk-muted: #64748b;\n  --mk-faint: #94a3b8;\n  --mk-ghost: #b4bcca;\n  --mk-line: #e6e9ef;\n  --mk-line-soft: #eef1f6;\n  --mk-surface: #f6f8fb;\n  --mk-surface-soft: #fafbfd;\n  --mk-dark: #0b1220;\n  --mk-panel: #0b1220;\n  --mk-accent: #3C87F7;\n  --mk-accent-dark: #1D68D9;\n  --mk-accent-bright: #5b9dff;\n  --mk-accent-tint: #eaf2fe;\n\n  min-height: 100%;\n  width: 100%;\n  background: #ffffff;\n  color: var(--mk-ink);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,\n    Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  line-height: 1.5;\n}\n\n.mk-root *,\n.mk-root *::before,\n.mk-root *::after {\n  box-sizing: border-box;\n}\n\n/* :where() so this contributes ZERO specificity. As a plain `.mk-root a` rule it\n   scored (0,1,1) and beat every single-class colour utility on an anchor — so a\n   `text-white` label on the near-black \"Get started\" button lost to the\n   inherited ink and rendered black on black. It still gives anchors the default\n   \"inherit, no underline\" look; it just no longer overrides a class that is\n   explicitly setting a colour. */\n:where(.mk-root a) {\n  color: inherit;\n  text-decoration: none;\n}\n\n/* ---------- Layout primitives ---------- */\n.mk-container {\n  width: 100%;\n  max-width: 1180px;\n  margin: 0 auto;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.mk-section {\n  padding-top: 88px;\n  padding-bottom: 88px;\n}\n\n.mk-section-sm {\n  padding-top: 56px;\n  padding-bottom: 56px;\n}\n\n@media (max-width: 640px) {\n  .mk-section {\n    padding-top: 60px;\n    padding-bottom: 60px;\n  }\n  .mk-container {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n\n/* ---------- Type ---------- */\n.mk-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--mk-accent-dark);\n}\n.mk-eyebrow-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--mk-accent);\n}\n\n.mk-h1,\n.mk-h2,\n.mk-h3 {\n  margin: 0;\n  color: var(--mk-ink);\n  letter-spacing: -0.022em;\n  font-weight: 600;\n  line-height: 1.07;\n}\n.mk-h1 {\n  font-size: 54px;\n}\n.mk-h2 {\n  font-size: 42px;\n}\n.mk-h3 {\n  font-size: 26px;\n  line-height: 1.15;\n}\n@media (max-width: 720px) {\n  .mk-h1 {\n    font-size: 38px;\n  }\n  .mk-h2 {\n    font-size: 30px;\n  }\n  .mk-h3 {\n    font-size: 22px;\n  }\n}\n.mk-muted-line {\n  color: var(--mk-ghost);\n}\n\n.mk-lead {\n  margin: 0;\n  font-size: 18px;\n  line-height: 1.6;\n  color: var(--mk-muted);\n}\n@media (max-width: 720px) {\n  .mk-lead {\n    font-size: 16px;\n  }\n}\n\n/* ---------- Buttons ---------- */\n.mk-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 12px 20px;\n  border: 1px solid transparent;\n  transition: background 0.15s, color 0.15s, border-color 0.15s, transform 0.15s;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.mk-btn:active {\n  transform: translateY(1px);\n}\n.mk-btn-primary {\n  background: var(--mk-dark);\n  color: #fff;\n}\n.mk-btn-primary:hover {\n  background: #1e293b;\n}\n.mk-btn-accent {\n  background: var(--mk-accent);\n  color: #fff;\n}\n.mk-btn-accent:hover {\n  background: var(--mk-accent-dark);\n}\n.mk-btn-secondary {\n  background: #fff;\n  color: var(--mk-ink);\n  border-color: var(--mk-line);\n}\n.mk-btn-secondary:hover {\n  background: var(--mk-surface-soft);\n  border-color: var(--mk-ghost);\n}\n.mk-btn-ghost {\n  background: transparent;\n  color: var(--mk-ink-soft);\n  padding: 9px 14px;\n}\n.mk-btn-ghost:hover {\n  background: var(--mk-surface);\n  color: var(--mk-ink);\n}\n.mk-btn-white {\n  background: #fff;\n  color: var(--mk-dark);\n}\n.mk-btn-white:hover {\n  background: rgba(255, 255, 255, 0.9);\n}\n.mk-btn-outline-white {\n  background: transparent;\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.25);\n}\n.mk-btn-outline-white:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n.mk-btn-lg {\n  padding: 14px 26px;\n  font-size: 15px;\n}\n\n/* ---------- Header ---------- */\n.mk-header {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  width: 100%;\n  border-bottom: 1px solid var(--mk-line-soft);\n  background: rgba(255, 255, 255, 0.82);\n  backdrop-filter: saturate(180%) blur(12px);\n}\n.mk-header-inner {\n  display: flex;\n  height: 64px;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n}\n.mk-logo {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 700;\n  font-size: 16px;\n  letter-spacing: -0.01em;\n  color: var(--mk-ink);\n}\n.mk-logo-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 9px;\n  background: linear-gradient(135deg, var(--mk-accent), var(--mk-accent-dark));\n  color: #fff;\n  font-size: 15px;\n  font-weight: 800;\n  flex: none;\n}\n.mk-nav {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 4px;\n  border-radius: 999px;\n  background: var(--mk-surface);\n}\n.mk-nav-item {\n  border-radius: 999px;\n  padding: 7px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--mk-muted);\n  transition: color 0.15s, background 0.15s;\n}\n.mk-nav-item:hover {\n  color: var(--mk-ink);\n}\n.mk-nav-item.mk-active {\n  color: var(--mk-ink);\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n.mk-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.mk-header-signin {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--mk-muted);\n  padding: 8px 10px;\n}\n.mk-header-signin:hover {\n  color: var(--mk-ink);\n}\n.mk-menu-btn {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 999px;\n  border: 1px solid var(--mk-line);\n  background: #fff;\n  color: var(--mk-ink);\n}\n.mk-mobile-menu {\n  border-top: 1px solid var(--mk-line-soft);\n  background: #fff;\n  padding: 8px 24px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.mk-mobile-item {\n  border-radius: 10px;\n  padding: 11px 12px;\n  font-size: 14px;\n  color: var(--mk-ink-soft);\n}\n.mk-mobile-item.mk-active {\n  background: var(--mk-surface);\n  font-weight: 600;\n  color: var(--mk-ink);\n}\n@media (max-width: 900px) {\n  .mk-nav {\n    display: none;\n  }\n  .mk-menu-btn {\n    display: inline-flex;\n  }\n  .mk-header-signin {\n    display: none;\n  }\n}\n\n/* ---------- Hero ---------- */\n.mk-hero {\n  padding-top: 72px;\n  padding-bottom: 40px;\n}\n.mk-hero-inner {\n  max-width: 760px;\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n}\n.mk-hero-center {\n  margin: 0 auto;\n  align-items: center;\n  text-align: center;\n}\n.mk-hero-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 6px;\n  flex-wrap: wrap;\n}\n.mk-hero-center .mk-hero-actions {\n  justify-content: center;\n}\n@media (max-width: 720px) {\n  .mk-hero {\n    padding-top: 48px;\n  }\n}\n\n/* ---------- Section intro ---------- */\n.mk-intro {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-width: 680px;\n}\n.mk-intro-center {\n  margin: 0 auto;\n  align-items: center;\n  text-align: center;\n}\n\n/* ---------- Cards ---------- */\n.mk-card {\n  border-radius: 20px;\n  border: 1px solid var(--mk-line);\n  background: #fff;\n  padding: 26px;\n  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;\n}\n.mk-card-soft {\n  border-color: transparent;\n  background: var(--mk-surface);\n}\n.mk-card-hover:hover {\n  border-color: var(--mk-ghost);\n  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.06);\n  transform: translateY(-2px);\n}\n\n.mk-dark {\n  position: relative;\n  overflow: hidden;\n  border-radius: 28px;\n  background: var(--mk-panel);\n  color: #fff;\n}\n\n.mk-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border-radius: 999px;\n  border: 1px solid var(--mk-line);\n  background: #fff;\n  color: var(--mk-muted);\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n}\n.mk-badge-accent {\n  border-color: #bfdcff;\n  background: var(--mk-accent-tint);\n  color: var(--mk-accent-dark);\n}\n.mk-badge-dark {\n  border-color: rgba(255, 255, 255, 0.16);\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n.mk-glyph {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  background: var(--mk-accent-tint);\n  color: var(--mk-accent-dark);\n  flex: none;\n}\n.mk-glyph-dark {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n/* ---------- Feature grid ---------- */\n.mk-grid {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: repeat(1, 1fr);\n}\n@media (min-width: 640px) {\n  .mk-grid-2,\n  .mk-grid-3,\n  .mk-grid-4 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (min-width: 960px) {\n  .mk-grid-3 {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .mk-grid-4 {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n.mk-feature-card {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.mk-feature-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.mk-feature-title {\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--mk-ink);\n}\n.mk-feature-body {\n  margin: 8px 0 0;\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--mk-muted);\n}\n\n/* ---------- Feature row (alternating) ---------- */\n.mk-featurerow {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 40px;\n  align-items: center;\n}\n@media (min-width: 960px) {\n  .mk-featurerow {\n    grid-template-columns: 1fr 1fr;\n    gap: 64px;\n  }\n  .mk-featurerow-reverse .mk-featurerow-text {\n    order: 2;\n  }\n}\n.mk-bullets {\n  list-style: none;\n  margin: 24px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.mk-bullet {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  font-size: 15px;\n  line-height: 1.5;\n  color: var(--mk-ink-soft);\n}\n.mk-bullet-check {\n  margin-top: 1px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 999px;\n  background: var(--mk-accent-tint);\n  color: var(--mk-accent-dark);\n  flex: none;\n}\n\n/* ---------- Stat band ---------- */\n.mk-statband {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1px;\n  overflow: hidden;\n  border-radius: 24px;\n  border: 1px solid var(--mk-line);\n  background: var(--mk-line);\n}\n@media (min-width: 768px) {\n  .mk-statband-4 {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  .mk-statband-3 {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n.mk-stat {\n  background: #fff;\n  padding: 32px 24px;\n  text-align: center;\n}\n.mk-stat-value {\n  font-size: 34px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--mk-ink);\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n.mk-stat-label {\n  margin-top: 8px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: var(--mk-faint);\n}\n\n/* ---------- Media / mock frames ---------- */\n.mk-frame {\n  border-radius: 18px;\n  border: 1px solid var(--mk-line);\n  background: var(--mk-surface-soft);\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n}\n.mk-frame-bar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--mk-line-soft);\n  background: #fff;\n}\n.mk-frame-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  background: #e2e8f0;\n}\n.mk-frame-body {\n  padding: 20px;\n}\n\n/* Bar/line mini viz used in mock frames */\n.mk-bars {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  height: 160px;\n}\n.mk-bars > span {\n  flex: 1;\n  border-radius: 6px 6px 0 0;\n  background: linear-gradient(180deg, var(--mk-accent-bright), var(--mk-accent));\n  opacity: 0.9;\n}\n.mk-metric-row {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n.mk-metric {\n  flex: 1;\n  border-radius: 12px;\n  border: 1px solid var(--mk-line-soft);\n  background: #fff;\n  padding: 12px 14px;\n}\n.mk-metric-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--mk-ink);\n}\n.mk-metric-label {\n  font-size: 12px;\n  color: var(--mk-faint);\n  margin-top: 2px;\n}\n\n/* ---------- CTA band ---------- */\n.mk-cta-inner {\n  padding: 72px 32px;\n  text-align: center;\n}\n.mk-cta-glow {\n  pointer-events: none;\n  position: absolute;\n  top: -120px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 460px;\n  height: 300px;\n  border-radius: 999px;\n  background: var(--mk-accent);\n  opacity: 0.22;\n  filter: blur(100px);\n}\n.mk-cta-content {\n  position: relative;\n  max-width: 640px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n}\n.mk-cta-title {\n  margin: 0;\n  font-size: 40px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1.08;\n  color: #fff;\n}\n.mk-cta-body {\n  margin: 0;\n  font-size: 16px;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.62);\n}\n.mk-cta-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 6px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n@media (max-width: 640px) {\n  .mk-cta-inner {\n    padding: 52px 22px;\n  }\n  .mk-cta-title {\n    font-size: 30px;\n  }\n}\n\n/* ---------- Accordion ---------- */\n.mk-accordion {\n  overflow: hidden;\n  border-radius: 20px;\n  border: 1px solid var(--mk-line);\n  background: #fff;\n}\n.mk-acc-item + .mk-acc-item {\n  border-top: 1px solid var(--mk-line-soft);\n}\n.mk-acc-btn {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 22px;\n  text-align: left;\n  background: transparent;\n  border: none;\n}\n.mk-acc-q {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 1.45;\n  color: var(--mk-ink);\n}\n.mk-acc-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  border: 1px solid var(--mk-line);\n  color: var(--mk-muted);\n  flex: none;\n  transition: transform 0.2s;\n}\n.mk-acc-open .mk-acc-icon {\n  transform: rotate(45deg);\n}\n.mk-acc-body {\n  padding: 0 48px 22px 22px;\n  font-size: 14px;\n  line-height: 1.65;\n  color: var(--mk-muted);\n}\n\n/* ---------- Steps ---------- */\n.mk-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.mk-step {\n  display: flex;\n  gap: 16px;\n  border-radius: 18px;\n  border: 1px solid var(--mk-line);\n  background: #fff;\n  padding: 22px;\n}\n.mk-step-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 999px;\n  background: var(--mk-dark);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  flex: none;\n}\n.mk-step-title {\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--mk-ink);\n}\n.mk-step-body {\n  margin: 6px 0 0;\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--mk-muted);\n}\n\n/* ---------- Quote ---------- */\n.mk-quote {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  height: 100%;\n}\n.mk-quote-text {\n  font-size: 17px;\n  line-height: 1.55;\n  letter-spacing: -0.01em;\n  color: var(--mk-ink);\n  margin: 0;\n}\n.mk-quote-foot {\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.mk-quote-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 999px;\n  background: var(--mk-dark);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  flex: none;\n}\n.mk-quote-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--mk-ink);\n}\n.mk-quote-role {\n  font-size: 12px;\n  color: var(--mk-faint);\n}\n\n/* ---------- Logo cloud ---------- */\n.mk-logocloud {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  text-align: center;\n  padding: 28px 0;\n  border-top: 1px solid var(--mk-line-soft);\n  border-bottom: 1px solid var(--mk-line-soft);\n}\n.mk-logocloud-label {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--mk-faint);\n}\n.mk-logocloud-list {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 10px 22px;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--mk-ghost);\n}\n.mk-logocloud-sep {\n  color: var(--mk-line);\n}\n\n/* ---------- Pricing ---------- */\n.mk-price-grid {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: 1fr;\n}\n@media (min-width: 960px) {\n  .mk-price-grid-3 {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .mk-price-grid-4 {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n.mk-price-card {\n  display: flex;\n  flex-direction: column;\n  border-radius: 22px;\n  border: 1px solid var(--mk-line);\n  background: #fff;\n  padding: 28px;\n}\n.mk-price-card-featured {\n  border-color: var(--mk-accent);\n  box-shadow: 0 12px 40px rgba(60, 135, 247, 0.16);\n  position: relative;\n}\n.mk-price-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--mk-ink);\n}\n.mk-price-tagline {\n  margin: 6px 0 0;\n  font-size: 13px;\n  color: var(--mk-muted);\n  min-height: 34px;\n}\n.mk-price-amount {\n  margin-top: 18px;\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n.mk-price-value {\n  font-size: 40px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--mk-ink);\n}\n.mk-price-period {\n  font-size: 14px;\n  color: var(--mk-faint);\n}\n.mk-price-features {\n  list-style: none;\n  margin: 22px 0 0;\n  padding: 22px 0 0;\n  border-top: 1px solid var(--mk-line-soft);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.mk-price-feature {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--mk-ink-soft);\n}\n.mk-price-feature .mk-bullet-check {\n  width: 18px;\n  height: 18px;\n}\n.mk-price-cta {\n  margin-top: 24px;\n}\n\n/* ---------- Timeline (changelog) ---------- */\n.mk-timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n.mk-tl-item {\n  display: grid;\n  grid-template-columns: 160px 1fr;\n  gap: 28px;\n  padding-bottom: 40px;\n  position: relative;\n}\n.mk-tl-rail {\n  position: relative;\n}\n.mk-tl-date {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--mk-faint);\n  position: sticky;\n  top: 90px;\n}\n.mk-tl-body {\n  border-left: 1px solid var(--mk-line);\n  padding-left: 28px;\n  padding-bottom: 8px;\n  position: relative;\n}\n.mk-tl-body::before {\n  content: '';\n  position: absolute;\n  left: -5px;\n  top: 6px;\n  width: 9px;\n  height: 9px;\n  border-radius: 999px;\n  background: var(--mk-accent);\n  box-shadow: 0 0 0 4px #fff;\n}\n@media (max-width: 720px) {\n  .mk-tl-item {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n  .mk-tl-body {\n    border-left: none;\n    padding-left: 0;\n  }\n  .mk-tl-body::before {\n    display: none;\n  }\n  .mk-tl-date {\n    position: static;\n  }\n}\n\n/* ---------- Blog / post grid ---------- */\n.mk-post {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  height: 100%;\n}\n.mk-post-thumb {\n  border-radius: 14px;\n  height: 168px;\n  background: linear-gradient(135deg, var(--mk-accent-tint), #dbe8ff);\n  position: relative;\n  overflow: hidden;\n}\n.mk-post-thumb-alt {\n  background: linear-gradient(135deg, #eef2f7, #dfe6f0);\n}\n.mk-post-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: var(--mk-faint);\n}\n.mk-post-title {\n  font-size: 17px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--mk-ink);\n  line-height: 1.3;\n}\n.mk-post-excerpt {\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--mk-muted);\n  margin: 0;\n}\n\n/* ---------- Careers / job list ---------- */\n.mk-jobgroup + .mk-jobgroup {\n  margin-top: 36px;\n}\n.mk-jobgroup-title {\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--mk-faint);\n  margin-bottom: 12px;\n}\n.mk-job {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 22px;\n  border: 1px solid var(--mk-line);\n  border-radius: 16px;\n  background: #fff;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n.mk-job + .mk-job {\n  margin-top: 10px;\n}\n.mk-job:hover {\n  border-color: var(--mk-ghost);\n  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.05);\n}\n.mk-job-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--mk-ink);\n}\n.mk-job-meta {\n  font-size: 13px;\n  color: var(--mk-faint);\n  margin-top: 3px;\n}\n\n/* ---------- Status ---------- */\n.mk-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 999px;\n  padding: 5px 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n.mk-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n}\n.mk-status-operational {\n  background: #ecfdf3;\n  color: #067647;\n}\n.mk-status-operational .mk-status-dot {\n  background: #17b26a;\n}\n.mk-status-degraded {\n  background: #fffaeb;\n  color: #b54708;\n}\n.mk-status-degraded .mk-status-dot {\n  background: #f79009;\n}\n.mk-status-maintenance {\n  background: #eff4ff;\n  color: #3538cd;\n}\n.mk-status-maintenance .mk-status-dot {\n  background: #6172f3;\n}\n.mk-status-outage {\n  background: #fef3f2;\n  color: #b42318;\n}\n.mk-status-outage .mk-status-dot {\n  background: #f04438;\n}\n.mk-uptime {\n  display: flex;\n  align-items: flex-end;\n  gap: 2px;\n}\n.mk-uptime-cell {\n  flex: 1;\n  max-width: 7px;\n  height: 30px;\n  border-radius: 2px;\n  background: #17b26a;\n}\n.mk-uptime-cell.mk-degraded {\n  background: #f79009;\n}\n.mk-uptime-cell.mk-outage {\n  background: #f04438;\n}\n.mk-status-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 22px;\n  border: 1px solid var(--mk-line);\n  border-radius: 14px;\n  background: #fff;\n}\n.mk-status-row + .mk-status-row {\n  margin-top: 10px;\n}\n\n/* ---------- Prose (legal / long text) ---------- */\n.mk-prose {\n  max-width: 760px;\n  color: var(--mk-ink-soft);\n}\n.mk-prose h2 {\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--mk-ink);\n  margin: 40px 0 12px;\n}\n.mk-prose h3 {\n  font-size: 17px;\n  font-weight: 600;\n  color: var(--mk-ink);\n  margin: 26px 0 8px;\n}\n.mk-prose p {\n  font-size: 15px;\n  line-height: 1.7;\n  color: var(--mk-ink-soft);\n  margin: 0 0 14px;\n}\n.mk-prose ul {\n  margin: 0 0 16px;\n  padding-left: 20px;\n}\n.mk-prose li {\n  font-size: 15px;\n  line-height: 1.7;\n  color: var(--mk-ink-soft);\n  margin-bottom: 6px;\n}\n.mk-prose a {\n  color: var(--mk-accent-dark);\n  font-weight: 500;\n}\n.mk-prose a:hover {\n  text-decoration: underline;\n}\n.mk-prose-lead {\n  font-size: 15px;\n  color: var(--mk-muted);\n}\n\n/* Two-column split for legal toc + content */\n.mk-legal {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 40px;\n}\n@media (min-width: 960px) {\n  .mk-legal {\n    grid-template-columns: 220px 1fr;\n    gap: 56px;\n  }\n}\n.mk-legal-toc {\n  position: sticky;\n  top: 90px;\n  align-self: start;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.mk-legal-toc a {\n  font-size: 13px;\n  color: var(--mk-muted);\n  padding: 4px 0;\n}\n.mk-legal-toc a:hover {\n  color: var(--mk-ink);\n}\n@media (max-width: 960px) {\n  .mk-legal-toc {\n    display: none;\n  }\n}\n\n/* ---------- Footer ---------- */\n.mk-footer {\n  border-top: 1px solid var(--mk-line-soft);\n  background: var(--mk-surface-soft);\n}\n.mk-footer-inner {\n  padding: 56px 0;\n}\n.mk-footer-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 40px 32px;\n}\n@media (min-width: 640px) {\n  .mk-footer-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media (min-width: 960px) {\n  .mk-footer-grid {\n    grid-template-columns: 1.5fr repeat(4, 1fr);\n  }\n}\n.mk-footer-brand {\n  grid-column: 1 / -1;\n}\n@media (min-width: 960px) {\n  .mk-footer-brand {\n    grid-column: auto;\n  }\n}\n.mk-footer-tagline {\n  margin: 16px 0 0;\n  max-width: 260px;\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--mk-faint);\n}\n.mk-footer-title {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--mk-faint);\n}\n.mk-footer-links {\n  list-style: none;\n  margin: 16px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.mk-footer-links a {\n  font-size: 13px;\n  color: var(--mk-muted);\n}\n.mk-footer-links a:hover {\n  color: var(--mk-ink);\n}\n.mk-social {\n  display: flex;\n  gap: 8px;\n  margin-top: 20px;\n}\n.mk-social a {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  border: 1px solid var(--mk-line);\n  color: var(--mk-faint);\n}\n.mk-social a:hover {\n  color: var(--mk-ink);\n  border-color: var(--mk-ghost);\n}\n.mk-footer-bottom {\n  margin-top: 48px;\n  padding-top: 24px;\n  border-top: 1px solid var(--mk-line-soft);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n@media (min-width: 640px) {\n  .mk-footer-bottom {\n    flex-direction: row;\n    align-items: center;\n  }\n}\n.mk-footer-copy {\n  font-size: 12px;\n  color: var(--mk-faint);\n}\n.mk-footer-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: var(--mk-faint);\n}\n.mk-footer-status:hover {\n  color: var(--mk-ink);\n}\n\n/* ---------- Generic helpers ---------- */\n.mk-center {\n  text-align: center;\n}\n@media (max-width: 640px) {\n  .mk-hide-sm {\n    display: none;\n  }\n}\n.mk-stack {\n  display: flex;\n  flex-direction: column;\n}\n.mk-mt-8 {\n  margin-top: 8px;\n}\n.mk-mt-16 {\n  margin-top: 16px;\n}\n.mk-mt-24 {\n  margin-top: 24px;\n}\n.mk-mt-32 {\n  margin-top: 32px;\n}\n.mk-mt-40 {\n  margin-top: 40px;\n}\n.mk-mt-56 {\n  margin-top: 56px;\n}\n.mk-divider {\n  height: 1px;\n  background: var(--mk-line-soft);\n  border: none;\n  margin: 0;\n}\n\n/* Reveal-on-scroll (progressive; static under reduced motion) */\n.mk-reveal {\n  opacity: 0;\n  transform: translateY(24px);\n  transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1),\n    transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);\n  will-change: opacity, transform;\n}\n.mk-reveal.mk-in {\n  opacity: 1;\n  transform: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .mk-reveal {\n    opacity: 1;\n    transform: none;\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
